// NPM Modules
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// Actions
import array from '../../../redux/actions/array';
// Components
import PageList from '../../../components/PageList';
import Page from '../../../components/Page';
import ArrayCreateDialog from '../../../components/Dialogs/ArrayCreateDialog';
/**
 * Array List Page
 */
class ArrayListPage extends Component {
  /**
   * state
   */
  state = {
    status: 'active',
    searchTerm: '',
    page_size: this.props.page_size,
    arrayCreateDialogOpen: false
  };
  /**
   * getArrayList
   */
  getArrayList(options = {}) {
    this.props.get({
      org_key: this.props.organization.org_key,
      page: options.page || 1,
      search: options.searchTerm || this.state.searchTerm,
      page_size: options.pageSize || this.props.page_size,
      status: options.status || this.state.status
    });
  }
  /**
   * componentDidMount
   */
  componentDidMount() {
    // Handle data fetching
    if (this.props.status === 'server') {
      if (
        new Date().getTime() - new Date(this.props.fetched).getTime() >
        5000
      ) {
        this.getArrayList();
      }
    } else {
      this.getArrayList();
    }
  }
  /**
   * handleOnSearch
   */
  handleOnSearch = searchTerm => {
    this.setState({ searchTerm });
    this.getArrayList({ searchTerm, page: 1 });
  };
  /**
   * handlePageChange
   */
  handlePageChange = page => {
    this.getArrayList({ page: page + 1 });
  };
  /**
   * handlePageSizeChange
   */
  handlePageSizeChange = pageSize => {
    this.getArrayList({ pageSize });
  };
  /**
   * handleStatusChange
   */
  handleStatusChange = event => {
    const status = event.target.value;
    this.setState({ status });
    this.getArrayList({ status });
  };
  /**
   * When array is created. Get array list and set array create dialog open to false
   */
  handleArrayCreated = () => {
    this.setState({ arrayCreateDialogOpen: false });
    this.getArrayList();
  };
  /**
   * render
   * Renders component visual.
   * @return {JSX} react component
   */
  render() {
    const { arrays, status, page, page_size, count, history } = this.props;
    const isLoading = status !== 'server' && status !== 'success';
    return (
      <Page>
        <PageList
          actions={
            this.props.organization.permissions.find(
              p => p === 'array_create_delete'
            )
              ? [
                  {
                    text: 'Add Array',
                    size: 'large',
                    variant: 'outlined',
                    marginLeft: 16,
                    onClick: () =>
                      this.setState({ arrayCreateDialogOpen: true })
                  }
                ]
              : []
          }
          options={{
            search: true,
            searchText: 'Search arrays',
            searchVariant: 'outlined',
            searchDebounceTime: 500,
            onSearch: this.handleOnSearch,
            isLoading: isLoading,
            count: count,
            pageSize: page_size,
            currentPage: page - 1,
            onPageChange: this.handlePageChange,
            onPageSizeChange: this.handlePageSizeChange,
            status: this.state.status,
            statusList: ['active', 'inactive'],
            onStatusChange: this.handleStatusChange
          }}
          list={arrays.map(array => ({
            title: array.array_name,
            subTitle: array.deployment_name,
            link: array.array_key,
            actions: [
              {
                text: 'View Array',
                size: 'small',
                marginLeft: 0
              }
            ]
          }))}
          history={history}
        />
        <ArrayCreateDialog
          open={this.state.arrayCreateDialogOpen}
          onArrayCreated={this.handleArrayCreated}
          onClose={() => this.setState({ arrayCreateDialogOpen: false })}
        />
      </Page>
    );
  }
  /**
   * static mapStateToProps
   * Maps the redux state to the component state.
   * @param {object} state redux state
   * @return {object} object of redux states
   */
  static mapStateToProps(state) {
    return {
      page: state.array.list.page.current,
      count: state.array.list.count,
      arrays: state.array.list.list,
      status: state.array.list.request.status,
      fetched: state.array.list.request.fetched,
      page_size: state.array.list.page.size,
      organization: state.organization.info.info
    };
  }
  /**
   * static mapDispatchToProps
   * Binds all the dispatch actions to one object.
   * @param {object} dispatch dispatch callback
   * @return {object} collectiong of dispatch actions
   */
  static mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        get: array.list.get,
        cancelGet: array.list.cancel
      },
      dispatch
    );
  }
}
/**
 * Export Module (React Component)
 * Wrap module in redux state connect for data and dispatching.
 */
export default connect(
  ArrayListPage.mapStateToProps,
  ArrayListPage.mapDispatchToProps
)(ArrayListPage);
